import React, { useEffect } from 'react';
import { ButtonGroup, Button } from 'ui';
import { useToggle } from 'hooks';
import Modal from 'components/shared/modal';

const PublishChangesButton = ({ onPublish, disabled, loading, isLinked }) => {
  const [modalVisible, toggleModalVisible] = useToggle();

  useEffect(() => {
    if (modalVisible && loading) {
      toggleModalVisible();
    }
  }, [toggleModalVisible, modalVisible, loading]);

  return (
    <>
      <Button
        primary
        loading={loading}
        disabled={disabled}
        className="fz-bigger ml-16"
        onClick={isLinked ? toggleModalVisible : onPublish}
      >
        {t('element_builder.publish_changes.button')}
      </Button>
      <Modal
        show={modalVisible}
        dismissCallback={toggleModalVisible}
        title={t('element_builder.publish_changes_confirmation.title')}
      >
        <div className="mb-24">
          <b>
            {t('element_builder.publish_changes_confirmation.publish_notice')}
          </b>
        </div>
        <ButtonGroup alignEnd>
          <Button onClick={toggleModalVisible}>{t('common.cancel')}</Button>
          <Button primary onClick={onPublish}>
            {t('element_builder.publish_changes.button')}
          </Button>
        </ButtonGroup>
      </Modal>
    </>
  );
};

export default PublishChangesButton;
